"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZonas = getZonas;

require("core-js/modules/es.array.concat.js");

var _ApiUtils = require("@/utils/ApiUtils");

var _axios = _interopRequireDefault(require("axios"));

var ZONAS_URL = process.env.VUE_APP_CONSULTAS_URL + '/zona';

function getZonas(idFuero) {
  var promise = _axios.default.get("".concat(ZONAS_URL, "?fuero=").concat(idFuero)).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  });

  return promise.then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
}